"use strict";

import get from "lodash/get";

// Utilities
import { Constants } from "customer-sdk/constants";

const OAUTH_CONNECTIONS = Constants.OAUTH_CONNECTIONS;
export const getters = {
  accountVerificationError: (state) => {
    if (state.verifyAccountError) {
      if (state.verifyAccountError.message)
        return state.verifyAccountError.message;
      return String(state.verifyAccountError);
    }
    return null;
  },
  authErrorMessage: (state) => state.errorMessage,
  authErrorReference: (state) => state.errorReference,
  mfaUserEmail: (state) => state.userDetails.email,
  mfaUserPhone: (state) => state.userDetails.phone,
  mfaUserPreferredChannel: (state) => state.preferredChannel,
  mfaRemainingAttempts: (state) => state.remainingAttempts,
  mfaInvalidCode: (state) => state.invalidMfaCode,
  mfaValidCode: (state) => state.validMfaCode,
  mfaRequired: (state) => state.isMfaRequired,
  mfaTemporaryBlocked: (state) => state.isTemporaryBlocked,
  mfaTemporaryBlockedTime: (state) => state.temporaryBlockedTime,
  mfaBlocked: (state) => state.isBlocked,
  oauthConnections: () => OAUTH_CONNECTIONS,
  renderOTP: (state) => {
    return state.isMfaRequired || state.isTemporaryBlocked || state.isBlocked;
  },
  renderPendingAccountVerification: (state) =>
    state.isPendingAccountVerification,
  renderPostVerification: (state, getters) => {
    return state.isPendingAccountVerification || getters.renderOTP;
  },
  renderLoginRequired: (state) => {
    return state.isPendingAccountLinking;
  },
  pendingAccountLinkingEmail: (state) => {
    return get(state, "pendingAccountLinkingProfile.email", null);
  },
  pendingAccountLinkingProviderName: (state) => {
    const identityProvider = get(
      state,
      "pendingAccountLinkingProfile.identityProvider"
    );
    if (identityProvider) {
      console.log("identityProvider", identityProvider);
      const provider = OAUTH_CONNECTIONS.find(
        (oauth) => String(oauth.connection) === String(identityProvider)
      );
      if (provider) {
        return provider.name;
      }
    }
    return "";
  },
};
